export default "__VITE_PUBLIC_ASSET__cdf42800__"